import React, { useState } from "react";
import { Slider } from "antd";


const CustomSlide = React.memo(({
  title,
  min,
  max,
  first,
  setter,
  apply,
  step = 1,
  more = false,
  unit = "",
  extraMax = "",
  dateConvert = false,
  checkcriteria = null,
  exceed = null,
  timeline = false
}) => {
  const [slideDisabled, setSlideDisabled] = useState(exceed != null ? exceed.sample : false);

  function dateSlide(value) {
    if (value === 0) {
      return '0m';
    }
    const years = Math.floor(value / 12);
    const months = value % 12;
    return `${years > 0 ? `${years}y` : ''}${months > 0 ? ` ${months}m` : ''}`.trim();
  }

  const defaultTooltip = dateConvert ? { formatter: dateSlide } : {};

  return (
    <div className="slideparent">
      {more ? (
        <div className="slideinfowrapper">
          <div className="slideinfo">
            {title} {unit && `(${unit})`}
          </div>
          <div className="morecheck">
            <p className="moretxt">{`${max}+`}</p>
            <input
              type="checkbox"
              className="nocheck"
              checked={exceed.sample}
              onChange={(e) => {
                exceed.set(e.target.checked);
                setSlideDisabled(e.target.checked);
              }}
            />
          </div>
        </div>
      ) : (
        <div className="slideinfo">
          {title} {unit && `(${unit})`}
        </div>
      )}

      <div className="slideelem">
        <p className="slidevals sleft">{min}</p>
        <Slider
          onAfterChange={apply}
          tooltip={
            slideDisabled
              ? {
                  ...defaultTooltip,
                  open: false,
                }
              : { ...defaultTooltip }
          }
          max={max}
          min={min}
          range={true}
          style={{ width: 'calc(100% - 2rem)' }}
          defaultValue={first}
          onChange={(val) => {
            setter(val);
          }}
          step={step}
          disabled={slideDisabled}
        />
        <p className="slidevals sright">{extraMax ? extraMax : max}</p>
      </div>
    </div>
  );
});

export default CustomSlide;